import React from 'react';
import PropTypes from 'prop-types';

import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

export class CompReportAttributeRow extends React.Component {
  static propTypes = {
    ...listItemPropTypes,
    option: PropTypes.object.isRequired,
    onRemoveAttribute: PropTypes.func
  }

  render() {
    const { option } = this.props;

    const style = {
      opacity: this.props.isDragging ? 0 : 1,
    };

    return this.props.connectDragPreview(this.props.connectDropTarget(this.props.connectDragSource(
      <div
        className="p-3 cursor-move list-group-item border-bottom d-flex align-items-center justify-content-between selectable"
        name="attributeRow"
        style={style}
      >
        <div>
          <span className="pe-2 text-muted">
            <FontAwesomeIcon icon={faEllipsisV}/>
          </span>
          {option['label']}
        </div>
        <span className="float-end">
          <FontAwesomeIcon
            className="text-danger clickable"
            icon={faTrashAlt}
            name="remove"
            onClick={() => this.props.onRemoveAttribute(option)}
          />
        </span>
      </div>
    )));
  }
}

export default reorderableListItem(CompReportAttributeRow, 'CompReportAttributeSelector', {
  beginDrag(props) {
    return {
      index: props.index,
      option: props.option
    };
  }
});
